import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { BaseCalendarComponent } from '../base-calendar/base-calendar.component';
import { DrupalRESTService } from 'src/app/services/drupal-rest.service';
import { NgForm } from '@angular/forms';
import moment from 'moment';
import 'moment-timezone';
import { FullCalendarComponent } from '@fullcalendar/angular';
import { ChangeDetectorRef, ElementRef, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DialogService } from 'src/app/services/dialog.service';
import { EntityRESTService } from 'src/app/services/entity-rest.service';
import { FieldsService } from 'src/app/services/fields.service';
import { TaxonomyService } from 'src/app/services/taxonomy.service';
import { UtilityService } from 'src/app/services/utility.service';
import { AuthRESTService } from 'src/app/services/auth-rest.service';
import { AuthService } from 'src/app/services/auth.service';
import { MenuRESTService } from 'src/app/services/menu-rest.service';
import { RouteEventsService } from 'src/app/route-events.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { ConfigPagesService } from 'src/app/services/config-pages.service';
import { PackagesService } from 'src/app/services/packages.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserService } from 'src/app/services/user.service';
import { DomSanitizer } from '@angular/platform-browser';
import { RefreshService } from 'src/app/services/refresh.service';
import { StudioConfigService } from 'src/app/services/studio-config.service';
import { LocalizationService } from 'src/app/services/localization.service';
import { ComponentRefreshService } from 'src/app/services/component-refresh.service';
import { LessonComponent } from 'src/app/components/forms/lesson/lesson.component';
import { GroupLessonComponent } from 'src/app/components/forms/group-lesson/group-lesson.component';
import { SchedulesComponent } from 'src/app/components/forms/schedules/schedules.component';
import { ServicesComponent } from 'src/app/components/forms/services/services.component';
import { EventLessonEntityComponent } from 'src/app/components/forms/event-lesson-entity/event-lesson-entity.component';
import { EventSchedulesEntityComponent } from 'src/app/components/forms/event-schedules-entity/event-schedules-entity.component';
import { EventGroupLessonEntityComponent } from 'src/app/components/forms/event-group-lesson-entity/event-group-lesson-entity.component';
import { EventServicesEntityComponent } from 'src/app/components/forms/event-services-entity/event-services-entity.component';
import { StudentDashboardWrapperComponent } from '../../student/student-dashboard-wrapper/student-dashboard-wrapper.component';
import { ComponentType } from '@angular/cdk/portal';
import { TranslateService } from '@ngx-translate/core';
import { WeekCalculationService } from 'src/app/services/week-calculation.service';
import { EventColorService } from 'src/app/services/event-color.service';
import { CalendarWeekChangeEvent } from '../../shared/calendar-week-selector/calendar-week-selector.component';
import { LoggerService } from '../../../services/logger.service';

@Component({
  selector: 'app-new-week-view',
  templateUrl: './new-week-view.component.html',
  styleUrls: ['./new-week-view.component.css']
})
export class NewWeekViewComponent extends BaseCalendarComponent implements OnInit, OnDestroy {
  // Component references for dialog handling
  override LessonComponent = LessonComponent;
  override GroupLessonComponent = GroupLessonComponent;
  override SchedulesComponent = SchedulesComponent;
  override ServicesComponent = ServicesComponent;
  override EventLessonEntityComponent = EventLessonEntityComponent;
  override EventSchedulesEntityComponent = EventSchedulesEntityComponent;
  override EventGroupLessonEntityComponent = EventGroupLessonEntityComponent;
  override EventServicesEntityComponent = EventServicesEntityComponent;
  StudentDashboardWrapperComponent = StudentDashboardWrapperComponent;

  // Copy/paste functionality
  override copyData = {};

  // Filter configuration
  override filterInstructorCategory: string[];
  override filterLessonType: any;
  lessonTypeOptions: any[] = [];
  override filterInstructor: string[] = [];
  override filterStudent: string = "";
  override filterDate: string = "";
  override filterGroupLesson: boolean = false;
  override filterLesson: boolean = false;
  override filterServices: boolean = false;
  filterDateDisplay: string;
  autoCompleteOptions: any;

  // Added from old week-view component
  field_instructor: any = null;
  CalendarWeekViewForYearData: any;

  // Studio timezone properties (matching day view pattern)
  studioTimezone: string = 'America/New_York';
  studioTimezoneLoaded: boolean = false;
  studioTimezoneMissing: boolean = false;

  @ViewChild(NgForm) override f: NgForm;
  @ViewChild('calendar') override calendarComponent: FullCalendarComponent;

  constructor(
    refreshService: RefreshService,
    dialogService: DialogService,
    entityRESTService: EntityRESTService,
    utilityService: UtilityService,
    fieldsService: FieldsService,
    drupalRESTService: DrupalRESTService,
    taxonomyService: TaxonomyService,
    router: Router,
    activatedRoute: ActivatedRoute,
    authRESTService: AuthRESTService,
    authService: AuthService,
    menuRESTService: MenuRESTService,
    formBuilder: FormBuilder,
    routeEventsService: RouteEventsService,
    permissionsService: PermissionsService,
    renderer2: Renderer2,
    configPages: ConfigPagesService,
    packagesService: PackagesService,
    snackBar: MatSnackBar,
    userRESTService: UserService,
    el: ElementRef,
    changeDetectorRef: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    private studioConfigService: StudioConfigService,
    private componentRefreshService: ComponentRefreshService,
    private translateService: TranslateService,
    weekCalculationService: WeekCalculationService,
    private localizationService: LocalizationService,
    eventColorService: EventColorService
  ) {
    super(
      refreshService,
      dialogService,
      entityRESTService,
      utilityService,
      fieldsService,
      drupalRESTService,
      taxonomyService,
      router,
      activatedRoute,
      authRESTService,
      authService,
      menuRESTService,
      formBuilder,
      routeEventsService,
      permissionsService,
      renderer2,
      configPages,
      packagesService,
      snackBar,
      userRESTService,
      el,
      changeDetectorRef,
      sanitizer,
      studioConfigService,
      componentRefreshService,
      translateService,
      weekCalculationService,
      eventColorService
    );
    this.CalendarWeekViewForYearData = this._fieldsService.CalendarWeekViewForYearData(true);
  }

  override ngOnInit(): void {
    super.ngOnInit();

    // Disable drag-and-drop for users without lessons_edit permission.
    const canEdit = this._permissionsService.canAccess('lessons_edit');
    this.calendarOptions.editable = canEdit;
    this.calendarOptions.droppable = canEdit;

    this.getAMTFilterConfiguration();

    // Initialize filterDate to current week's Sunday (start of week)
    // This syncs with the calendar's default view and the dropdown
    this.filterDate = moment().day(0).format('YYYY-MM-DD');
    this.filterDateDisplay = `Week # ${this.weekCalculationService.getWeekNumber(this.filterDate)}`;

    // Load studio timezone before calendar renders (calendar is guarded by *ngIf="studioTimezoneLoaded")
    this.loadStudioTimezone();

    // Subscribe to calendar refresh events from the ComponentRefreshService
    // This handles refreshes triggered from menu actions (Add Enrollment, Add Package, Add Payment)
    this.calendarRefreshSubscription = this.componentRefreshService.calendarRefresh$.subscribe(() => {
      LoggerService.log('Calendar refresh triggered from menu action in week view');
      this.refreshCalendarWithDatePreservation();
    });
  }

  // Menu-triggered refreshes and studio config are app-lifetime streams; without
  // releasing them every past week view keeps refetching on each menu refresh.
  private calendarRefreshSubscription: Subscription;
  private studioConfigSubscription: Subscription;

  override ngOnDestroy(): void {
    this.calendarRefreshSubscription?.unsubscribe();
    this.studioConfigSubscription?.unsubscribe();
    super.ngOnDestroy();
  }

  override getAMTFilterConfiguration() {
    let endpoint = "/api/dayview/calendar/filterInit";

    this._drupalRESTService.httpGET(endpoint)
      .subscribe(data => {
        this.lessonTypeOptions = data['lessonTypes'];
        this.filterInstructorCategory = data['teacherCategory'];
        this.filterInstructor = data['teacherCategory'];
      });
  }

  // Override to prioritize the filtered instructor over the clicked calendar cell
  override openEntityComponent(component: any, eckType: string, bundle: string, action: string, EntityID?: any, fieldsData: any = {}) {
    // Use the selected instructor from filter if available
    if (this.field_instructor && bundle === 'lessons') {
      fieldsData['field_instructor'] = this.field_instructor;
    } else if (this.field_instructor && bundle === 'services') {
      fieldsData['field_executive'] = this.field_instructor;
    } else if (this.field_instructor && bundle === 'schedules') {
      fieldsData['field_schedule_instructor'] = [this.field_instructor];
    } else if (this.field_instructor && bundle === 'group_lesson') {
      fieldsData['field_instructor'] = [this.field_instructor];
    }

    // Call the parent method to open the dialog with enhanced fieldsData
    super.openEntityComponent(component, eckType, bundle, action, EntityID, fieldsData);
  }

  override updateCalendarEvents(params: any) {
    LoggerService.log("updateCalendarEvents called...");
    LoggerService.log('params', params);

    // Update calendar date if available
    if (this.calendarComponent && this.f?.form.value.calendar_date) {
      this.calendarComponent.getApi().gotoDate(moment(this.f.form.value.calendar_date).toISOString());
    }

    // Update filter date display using custom week calculation
    const weekNum = this.weekCalculationService.getWeekNumber(this.filterDate);
    this.filterDateDisplay = `Week # ${weekNum}`;

    // Extract filter values correctly
    if (params && params.form) {
      const formValues = params.form.value;

      // Handle instructor filter
      if (formValues.filterInstructor) {
        this.filterInstructor = formValues.filterInstructor;
      }

      if (formValues.filterLessonType) {
        this.filterLessonType = formValues.filterLessonType;
      }

      // Handle student filter
      if (formValues.filterStudent) {
        this.filterStudent = formValues.filterStudent;
      }

      // Handle calendar date
      if (formValues.calendar_date) {
        this.filterDate = formValues.calendar_date;
      }

      // Handle checkboxes
      if (formValues.filterGroupLesson !== undefined) {
        this.filterGroupLesson = formValues.filterGroupLesson;
      }

      if (formValues.filterLesson !== undefined) {
        this.filterLesson = formValues.filterLesson;
      }

      if (formValues.filterServices !== undefined) {
        this.filterServices = formValues.filterServices;
      }

      if (formValues.filterHiddenEvents !== undefined) {
        this.filterHiddenEvents = formValues.filterHiddenEvents;
      }
    }

    // Refresh calendar to apply filters
    this.refreshCalendar();
  }

  onCalendarWeekChange(event: CalendarWeekChangeEvent): void {
    this.filterDate = event.date;
    this.filterDateDisplay = event.weekDisplay;

    // Navigate the calendar to the selected date
    if (this.calendarComponent?.getApi()) {
      this.calendarComponent.getApi().gotoDate(moment(event.date).toISOString());
    }

    // Refresh calendar to load events for new date
    this.refreshCalendar();
  }

  // Override the getCalendarEvents to ensure proper parameter handling
  override getCalendarEvents(filterParamsOverride: any = null) {
    return (fetchInfo: any, successCallback: (events: any[]) => void, failureCallback: (error: any) => void) => {
      // CRITICAL: Wait for studio timezone to load before fetching events
      // This ensures all time calculations are correct for the studio's timezone
      if (!this.studioTimezoneLoaded) {
        LoggerService.log('[WEEK-VIEW] Waiting for studio timezone to load, returning empty events');
        return successCallback([]);
      }

      // Base endpoint
      let endpoint = this.getEventsEndpoint();

      // Extract the date from fetchInfo.startStr which is already in studio timezone
      // Use split('T') instead of moment() to avoid timezone conversion shifting the date
      const startDateOnly = fetchInfo.startStr.split('T')[0];
      const endDateOnly = fetchInfo.endStr.split('T')[0];

      this.newDateStart = startDateOnly + 'T00:00:00';
      this.newDateEnd = endDateOnly + 'T00:00:00';

      // Keep filter panel week display in sync when navigating with prev/next
      const dateForWeekCalc = moment.tz(startDateOnly + ' 12:00', this.studioTimezone).toISOString();
      const weekNum = this.weekCalculationService.getWeekNumber(dateForWeekCalc);
      const weekYear = this.weekCalculationService.getCorrectYearForWeek(dateForWeekCalc);
      this.filterDate = startDateOnly;
      this.filterDateDisplay = `Week ${weekNum.toString().padStart(2, '0')}, ${weekYear}`;

      // Build query parameters
      let queryParams = [];
      queryParams.push(`start=${this.newDateStart}`);
      queryParams.push(`end=${this.newDateEnd}`);

      const values = this.f?.form?.value || {};

      // Add calendar date
      if (values.calendar_date && values.calendar_date !== "") {
        queryParams.push(`calendar_date=${moment(values.calendar_date).format("YYYY-MM-DD")}`);
      }

      // Add student filter
      if (values.filterStudent && values.filterStudent !== "") {
        queryParams.push(`student=${encodeURIComponent(values.filterStudent)}`);
      }

      // Add lesson type filter - ensure we're sending ID only
      if (values.filterLessonType) {
        queryParams.push(`lessonType=${values.filterLessonType}`);
      }

      // Add instructor filter - ensure we're sending ID only
      if (values.filterInstructor) {
        queryParams.push(`instructor=${values.filterInstructor}`);
      }

      // Add checkbox filters
      if (values.filterGroupLesson) {
        queryParams.push(`group_lesson=${values.filterGroupLesson}`);
      }

      if (values.filterLesson) {
        queryParams.push(`lesson=${values.filterLesson}`);
      }

      if (values.filterServices) {
        queryParams.push(`services=${values.filterServices}`);
      }

      if (values.filterHiddenEvents) {
        queryParams.push(`hidden_events=${values.filterHiddenEvents}`);
      }

      // Join all parameters into URL
      endpoint = `${endpoint}${queryParams.join('&')}`;

      // Make the API call
      this._drupalRESTService.httpGET(endpoint).subscribe(
        (data: any[]) => {
          this.Events = data || [];
          successCallback(this.Events);
        },
        error => {
          LoggerService.error('Error fetching calendar events:', error);
          this.Events = [];
          successCallback([]);
        }
      );
    };
  }

  // Override handleSelect to prioritize the filtered instructor
  override handleSelect(info: any): void {
    super.handleSelect(info);

    // If an instructor is selected in the filter, use it instead of the clicked resource
    if (this.field_instructor) {
      this.currentSelectedInstructorID = this.field_instructor;
    }
  }

  // Handle the autocomplete for student field
  onStudentInput($event: { target: { value: string; }; }) {
    let term: string = $event.target.value;
    let eckType: string = "student_accounts";
    let bundle: string = "student_account";
    let field: string = "title";

    // Build the endpoint
    let endpoint: string = "/api_rest/v1/autocomplete?";
    endpoint = endpoint + "term=" + term;
    endpoint = endpoint + "&eckType=" + eckType;
    endpoint = endpoint + "&bundle=" + bundle;
    endpoint = endpoint + "&field=" + field;

    // Do the request
    this._drupalRESTService.httpGET(endpoint)
      .subscribe(data => {
        this.autoCompleteOptions = data;
      });
  }

  // Method to extract student ID from the filter input and open student dashboard
  openStudentDashboard(event?: Event) {
    // Prevent the click from triggering the autocomplete dropdown
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }

    if (!this.f || !this.f.form.value.filterStudent) {
      return;
    }

    const studentValue = this.f.form.value.filterStudent.trim();

    // Extract student account ID from the format "Student Name (ID)"
    const match = studentValue.match(/\((\d+)\)$/);
    if (match && match[1]) {
      const studentAccountId = match[1];

      // First, get the student account to extract the contact ID
      this._entityRESTService.getEntity('student_accounts', 'student_account', studentAccountId)
        .subscribe({
          next: (studentAccount: any) => {
            // Extract contact ID from field_contacts (handle both single object and array)
            let contactId = null;

            if (studentAccount?.field_contacts) {
              if (Array.isArray(studentAccount.field_contacts)) {
                // If multiple contacts, use the first one
                contactId = studentAccount.field_contacts[0]?.id || studentAccount.field_contacts[0]?.target_id;
              } else {
                // Single contact object
                contactId = studentAccount.field_contacts.id || studentAccount.field_contacts.target_id;
              }
            }

            if (contactId) {
              // Open dashboard with the contact ID
              this.openDialog(this.StudentDashboardWrapperComponent, 'largerScreenDashboard', { student_id: contactId });
            } else {
              LoggerService.error('No contact ID found in student account:', studentAccount);
              if (this._snackBar) {
                this._snackBar.open('Unable to find student contact information', 'Close', {
                  duration: 3000,
                });
              }
            }
          },
          error: (error) => {
            LoggerService.error('Error fetching student account:', error);
            if (this._snackBar) {
              this._snackBar.open('Error loading student information', 'Close', {
                duration: 3000,
              });
            }
          }
        });
    }
  }

  protected override getInitialView(): string {
    return 'timeGridWeek';
  }

  protected override getHeaderToolbar(): any {
    return {
      start: 'today prev,next',
      center: 'title',
      end: ''
    };
  }

  protected override formatCalendarTitle(dateInfo: any): string {
    // Use the year/month/day properties directly to avoid timezone conversion issues
    // when .marker (UTC ISO string) gets converted to local time
    const startYear = dateInfo.start.year;
    const startMonth = dateInfo.start.month; // 0-indexed
    const startDay = dateInfo.start.day;

    const endYear = dateInfo.end.year;
    const endMonth = dateInfo.end.month; // 0-indexed
    const endDay = dateInfo.end.day;

    // Create moment objects using the explicit date components (not UTC strings)
    const startMoment = moment([startYear, startMonth, startDay]);
    const endMoment = moment([endYear, endMonth, endDay]);

    const start = startMoment.format('MMMM Do');
    const end = endMoment.format('MMMM Do[, ]YYYY');

    // Use custom week calculation for correct Week 53 handling
    const weekNumber = this.weekCalculationService.getWeekNumber(endMoment.toISOString());

    const title = start + ' - ' + end + ' - Week # ' + weekNumber;
    return title;
  }

  getNameFromId(index: any, obj: any[], key: string = 'value') {
    let item = obj?.find((element) => {
      return element.id == index || element.uid == index;
    });
    return item?.[key];
  }

  // Override getCalendarResources to ensure proper processing of resources
  override getCalendarResources(filterParamsOverride: any = null) {
    return (fetchInfo: any, successCallback: (resources: any[]) => void, failureCallback: (error: any) => void) => {
      // CRITICAL: Wait for studio timezone to load before fetching resources
      if (!this.studioTimezoneLoaded) {
        LoggerService.log('[WEEK-VIEW] Waiting for studio timezone to load, returning empty resources');
        return successCallback([]);
      }

      // Set business hours based on office_hours configuration
      this.setWeekViewBusinessHours();

      let endpoint = this.getResourcesEndpoint();

      // Extract date-only and interpret in studio timezone for consistent week calculation
      const dateOnly = fetchInfo.startStr.split('T')[0];
      // Create a date string at noon in studio timezone to avoid any day boundary issues
      const dateForWeekCalc = moment.tz(dateOnly + ' 12:00', this.studioTimezone).toISOString();

      const queryParams = [
        `start=${fetchInfo.startStr}`,
        `end=${fetchInfo.endStr}`,
        // Using custom week calculation to handle Week 53 logic correctly
        `week=${this.weekCalculationService.getWeekNumber(dateForWeekCalc)}`,
        `year=${this.weekCalculationService.getCorrectYearForWeek(dateForWeekCalc).toString()}`
      ];

      const activeFilters = filterParamsOverride || {
        filterInstructorCategory: this.filterInstructorCategory,
      };

      if (activeFilters.filterInstructorCategory && activeFilters.filterInstructorCategory.length > 0) {
        // Extract IDs from category objects (each has {id, name}) to match day-view behavior
        const categoryIds = activeFilters.filterInstructorCategory.map((cat: any) => cat.id || cat);
        queryParams.push(`instructor_category=${categoryIds.join(',')}`);
      }

      endpoint += queryParams.join('&');

      this._drupalRESTService.httpGET(endpoint).subscribe({
        next: (data: any) => {
          this.Resources = Array.isArray(data) ? data : [];

          // Ensure each resource has the 'info' property for tooltips
          this.Resources.forEach(resource => {
            if (!resource.extendedProps) {
              resource.extendedProps = {};
            }

            // If info is missing, generate it from available data
            if (!resource.extendedProps.info) {
              const instructorName = resource.title || 'Instructor';
              let infoHtml = `<div class="instructor-info">`;
              infoHtml += `<h4>${instructorName}</h4>`;

              // Add lesson counts if available
              if (resource.privateLesson && Array.isArray(resource.privateLesson)) {
                infoHtml += `<p>Private Lessons: ${resource.privateLesson[0] || 0} (daily) / ${resource.privateLesson[1] || 0} (weekly)</p>`;
              }

              if (resource.privatePostedLesson && Array.isArray(resource.privatePostedLesson)) {
                infoHtml += `<p>Taken Lessons: ${resource.privatePostedLesson[0] || 0} (daily) / ${resource.privatePostedLesson[1] || 0} (weekly)</p>`;
              }

              infoHtml += `</div>`;
              resource.extendedProps.info = infoHtml;
            }
          });

          this.calcSummary(this.Resources);
          successCallback(this.Resources);
        },
        error: (error) => {
          LoggerService.error('Error fetching calendar resources:', error);
          this.handleError(error);
          failureCallback(error);
        }
      });
    };
  }

  // Override resourcesEndpoint to use the same endpoint as day view
  protected override getResourcesEndpoint(): string {
    return "/api/dayview/calendar/resources?";
  }

  /**
   * Set business hours for week view using office_hours from AMTCalendarConfiguration
   * This matches how day view handles studio hours, using the actual configured office hours
   * rather than session time slots
   */
  private setWeekViewBusinessHours(): void {
    const officeHours = this.AMTCalendarConfiguration?.['office_hours'];

    // If AMTCalendarConfiguration hasn't loaded yet, don't apply defaults - just wait
    // The calendar will be updated when the config loads
    // Check for falsy values (null, undefined, empty string) and also empty objects
    if (!this.AMTCalendarConfiguration ||
        (typeof this.AMTCalendarConfiguration === 'object' && Object.keys(this.AMTCalendarConfiguration).length === 0)) {
      LoggerService.log('[WEEK-VIEW] AMTCalendarConfiguration not yet loaded, skipping business hours setup');
      return;
    }

    // Check if we have valid office hours configuration
    if (!officeHours) {
      LoggerService.log('[WEEK-VIEW] No office hours configuration found, using defaults');
      this.applyDefaultCalendarHours();
      return;
    }

    LoggerService.log('[WEEK-VIEW] Setting business hours from office_hours config:', officeHours);

    // Day names as used in office_hours config (capitalized, like moment().format('dddd'))
    const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    // Calculate the earliest start time and latest end time across all days
    let earliestStart = '24:00:00';
    let latestEnd = '00:00:00';
    let hasAnyHours = false;

    // Build business hours array for FullCalendar
    const businessHoursConfig: any[] = [];

    daysOfWeek.forEach((dayName, index) => {
      const dayHours = officeHours[dayName];

      if (dayHours?.start && dayHours?.end) {
        hasAnyHours = true;

        LoggerService.log(`[WEEK-VIEW] ${dayName}: ${dayHours.start} - ${dayHours.end}`);

        // Track earliest and latest times for overall slot range
        if (dayHours.start < earliestStart) {
          earliestStart = dayHours.start;
        }
        if (dayHours.end > latestEnd) {
          latestEnd = dayHours.end;
        }

        // Add business hours for this day
        businessHoursConfig.push({
          daysOfWeek: [index], // 0=Sunday, 1=Monday, etc.
          startTime: dayHours.start,
          endTime: dayHours.end
        });
      }
    });

    if (!hasAnyHours) {
      LoggerService.log('[WEEK-VIEW] No valid office hours found for any day, using defaults');
      this.applyDefaultCalendarHours();
      return;
    }

    LoggerService.log(`[WEEK-VIEW] Overall time range: ${earliestStart} - ${latestEnd}`);
    this.applyBusinessHours(businessHoursConfig, earliestStart, latestEnd);
  }

  /**
   * Apply default calendar hours when no office hours are configured
   */
  private applyDefaultCalendarHours(): void {
    if (this.calendarComponent?.getApi()) {
      const api = this.calendarComponent.getApi();
      api.setOption('businessHours', false);
      api.setOption('slotMinTime', '08:00:00');
      api.setOption('slotMaxTime', '22:00:00');
      LoggerService.log('[WEEK-VIEW] Set default calendar time range: 08:00 to 22:00');
    } else if (this.calendarOptions) {
      this.calendarOptions.businessHours = false;
      this.calendarOptions.slotMinTime = '08:00:00';
      this.calendarOptions.slotMaxTime = '22:00:00';
      LoggerService.log('[WEEK-VIEW] Set default calendar time range in options: 08:00 to 22:00');
    }
  }

  // Helper method to apply business hours to the calendar
  private applyBusinessHours(businessHours: any[], earliestStart: string, latestEnd: string): void {
    // Set the overall slot times to show the full range
    const paddedStart = this.subtractTime(earliestStart, '00:15:00');
    const paddedEnd = this.addTime(latestEnd, '00:15:00');

    LoggerService.log('Applying business hours:', businessHours);
    LoggerService.log(`Setting calendar times: ${paddedStart} to ${paddedEnd}`);

    if (this.calendarComponent?.getApi()) {
      const api = this.calendarComponent.getApi();

      // Set business hours to highlight available times
      api.setOption('businessHours', businessHours);

      // Set overall slot range to accommodate all business hours
      api.setOption('slotMinTime', paddedStart);
      api.setOption('slotMaxTime', paddedEnd);

      LoggerService.log('Applied to calendar API');
    } else if (this.calendarOptions) {
      // Set in options if calendar not yet initialized
      this.calendarOptions.businessHours = businessHours;
      this.calendarOptions.slotMinTime = paddedStart;
      this.calendarOptions.slotMaxTime = paddedEnd;

      LoggerService.log('Applied to calendar options');
    } else {
      LoggerService.log('No calendar API or options available');
    }
  }

  // Helper method to subtract time from a time string
  private subtractTime(timeStr: string, subtractStr: string): string {
    const baseMoment = moment('2000-01-01 ' + timeStr);
    const [hours, minutes] = subtractStr.split(':').map(Number);
    const result = baseMoment.subtract(hours, 'hours').subtract(minutes, 'minutes');

    // Don't go before 00:00:00
    if (result.format('HH:mm:ss') > timeStr) {
      return '00:00:00';
    }

    return result.format('HH:mm:ss');
  }

  // Helper method to add time to a time string
  private addTime(timeStr: string, addStr: string): string {
    const baseMoment = moment('2000-01-01 ' + timeStr);
    const [hours, minutes] = addStr.split(':').map(Number);
    const result = baseMoment.add(hours, 'hours').add(minutes, 'minutes');

    const resultTime = result.format('HH:mm:ss');

    // Debug logging
    LoggerService.log(`Adding ${addStr} to ${timeStr} = ${resultTime}`);

    // Don't go past 24:00:00 - but this logic seems wrong, let me fix it
    if (result.date() > 1) {
      // If we've gone to the next day, cap at 24:00:00
      return '24:00:00';
    }

    return resultTime;
  }

  // Copy functionality from day-view component
  override copyClick() {
    const bundle = this.copyData?.['bundle'];
    const entityType = 'events';
    let componentType: ComponentType<unknown>;
    let fieldsData: any = {};
    const ensureArray = (value: any) => Array.isArray(value) ? value : (value ? [value] : []);

    this._entityRESTService.getEntity(entityType, bundle, this.copyData?.['id']).subscribe(data => {
      switch (bundle) {
        case 'lesson':
          componentType = EventLessonEntityComponent;
          fieldsData = {
            'field_type': data?.['field_type'],
            'field_instructor': data?.['field_instructor']?.['id'],
            'field_duration': this.copyData?.['eventDuration'],
            'field_date_and_time': data?.['field_date_and_time'],
            'field_student': [{
              'type': 'attendees',
              'bundle': 'attendance',
              'title': data?.['field_student']?.['title'],
              'field_description': data?.['field_student']?.['field_description'],
              'field_enrollment': data?.['field_student']?.['field_enrollment'],
              'field_status': '64', // Pending status
              'field_students': data?.['field_student']?.['field_students'],
              'field_student_account': (data?.['field_student']?.['title'] + ' (' + data?.['field_student']?.['field_student_account'] + ')'),
            }]
          };
          break;
        case 'services':
          componentType = EventServicesEntityComponent;
          fieldsData = {
            'field_type': data?.['field_type'],
            'field_executive': data?.['field_executive']?.['id'],
            'field_duration': this.copyData?.['eventDuration'],
            'field_date_and_time': data?.['field_date_and_time'],
            'field_notes': data?.['field_notes'],
            'field_student': [{
              'type': 'attendees',
              'bundle': 'attendance',
              'field_student_account': data?.['field_student']?.['field_student_account']
                ? `${data?.['field_student']?.['title']} (${data?.['field_student']?.['field_student_account']})`
                : undefined,
              'field_students': data?.['field_student']?.['field_students'],
            }]
          };
          break;
        case 'group_lesson':
          componentType = EventGroupLessonEntityComponent;
          fieldsData = {
            'field_type': data?.['field_type'],
            'field_instructor': ensureArray(data?.['field_instructor']?.['id']),
            'field_duration': this.copyData?.['eventDuration'],
            'field_date_and_time': data?.['field_date_and_time'],
            'field_students': ensureArray(data?.['field_students']).map(student => this.prepareStudentDataForWeekView(student))
          };
          break;
        case 'schedules':
          componentType = EventSchedulesEntityComponent;
          fieldsData = {
            'field_type': data?.['field_type'],
            'field_duration': this.copyData?.['eventDuration'],
            'field_date_and_time': data?.['field_date_and_time'],
            'field_schedule_instructor': [data?.['field_schedule_instructor']?.['id']],
          };
          break;
        default:
          LoggerService.error('Unsupported bundle type:', bundle);
          return;
      }

      this._dialogService.openDialog(componentType, "defaultWithData", {
        data: {
          EntityID: null,
          eckType: entityType,
          bundle: bundle,
          action: 'create',
          fieldsData: fieldsData,
        },
      }).afterClosed().subscribe(result => {
        // Skip refresh if the dialog already triggered one
        if (result?.refreshed) {
          return;
        }
        this.refreshCalendar();
      });
    });
  }

  private prepareStudentDataForWeekView(studentData: any): any {
    if (!studentData) return null;

    return {
      'type': 'attendees',
      'bundle': 'attendance',
      'title': studentData?.['title'],
      'field_description': studentData?.['field_description'],
      'field_enrollment': studentData?.['field_enrollment'],
      'field_status': '64', // Pending status
      'field_students': studentData?.['field_students'],
      'field_student_account': `${studentData?.['title']} (${studentData?.['field_student_account']})`,
    };
  }

  // Method to check if event is hidden
  override isEventHidden(): boolean {
    return this.copyData?.['field_exclude_from_display'] == 1;
  }

  // Event visibility toggle methods
  override hideClick() {
    this.toggleEventVisibility(true);
  }

  override unhideClick() {
    this.toggleEventVisibility(false);
  }

  override toggleEventVisibility(hide: boolean) {
    const bundle = this.copyData?.['bundle'];
    const entityType = 'events';
    const eventId = this.copyData?.['id'];

    if (!bundle || !eventId) {
      LoggerService.error('No event selected or missing bundle/id');
      return;
    }

    const patchData = {
      field_exclude_from_display: [{ value: hide }]
    };

    this._entityRESTService.patchEntity(entityType, bundle, eventId, patchData)
      .subscribe(
        response => {
          LoggerService.log(`Event ${hide ? 'hidden' : 'unhidden'} successfully`, response);
          this.refreshCalendar();
        },
        error => {
          LoggerService.error(`Error ${hide ? 'hiding' : 'unhiding'} event`, error);
          if (this._snackBar) {
            this._snackBar.open(`Failed to ${hide ? 'hide' : 'unhide'} event. Please try again.`, 'Close', {
              duration: 3000,
            });
          }
        }
      );
  }

  override closeContextMenu() {
    // This method would be used to close context menus if implemented in the template
  }

  /**
   * Override the refreshCalendar method.
   * Note: refetchEvents/refetchResources preserve the current date on their own, so we do not need
   * to capture and re-apply it. Calling gotoDate after refetch caused a second events fetch because
   * refetchResourcesOnNavigate triggers another fetch cycle.
   */
  override refreshCalendar(refresh = 0) {
    setTimeout(() => {
      if (this?.calendarComponent?.getApi()) {
        this.calendarComponent.getApi().refetchEvents();
        this.calendarComponent.getApi().refetchResources();
      }
    }, refresh);
  }

  /**
   * Refreshes the calendar while preserving the current date.
   * This method is called when refresh is triggered from menu actions.
   */
  private refreshCalendarWithDatePreservation(): void {
    if (!this.calendarComponent?.getApi()) {
      LoggerService.warn('Calendar API not available for refresh');
      return;
    }

    // Store the current date before refreshing
    const currentDate = this.calendarComponent.getApi().getDate();
    LoggerService.log('Preserving calendar date in week view:', currentDate);

    // Refresh events and resources
    this.calendarComponent.getApi().refetchEvents();
    this.calendarComponent.getApi().refetchResources();

    // Restore the calendar to the previously viewed date
    if (currentDate) {
      LoggerService.log('Restoring calendar date in week view:', currentDate);
      this.calendarComponent.getApi().gotoDate(currentDate);
    }
  }

    // Override getAMTSessionTime to update business hours when session times are loaded
  protected override getAMTSessionTime(): void {
    if (this._drupalRESTService) {
      this._drupalRESTService.httpGET("/api/dayview/calendar/configurations-session").subscribe(data => {
        LoggerService.log('Session times loaded:', data);
        this.AMTSessionTime = data;

        // Calculate and log the expected time range for debugging
        this.calculateAndLogTimeRange();

        // Force a complete refresh of the calendar to apply new business hours
        setTimeout(() => {
          if (this.calendarComponent?.getApi()) {
            const api = this.calendarComponent.getApi();

            // Force update the current view's time slot range using office_hours
            this.setWeekViewBusinessHours();

            // Refresh both events and resources to apply new time ranges
            api.refetchEvents();
            api.refetchResources();

            LoggerService.log('[WEEK-VIEW] Calendar fully refreshed with office hours');

            // Process session times again after calendar refresh
            setTimeout(() => {
              this.processAMTSessionTime();
            }, 300);
          }
        }, 200);
      });
    }
  }

  // Debug method to calculate and log time ranges
  private calculateAndLogTimeRange(): void {
    if (!this.AMTSessionTime) {
      LoggerService.log('No session times available');
      return;
    }

    const daysOfWeek = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    const sessionDuration = this.AMTCalendarConfiguration?.duration || "00:45:00";

    let earliestStart = '24:00:00';
    let latestEnd = '00:00:00';
    let hasAnyTimes = false;

    LoggerService.log('Session duration:', sessionDuration);

    daysOfWeek.forEach((day, index) => {
      if (this.AMTSessionTime[day] && Array.isArray(this.AMTSessionTime[day]) && this.AMTSessionTime[day].length > 0) {
        hasAnyTimes = true;
        const sessionTimes = this.AMTSessionTime[day].sort();
        const startTime = sessionTimes[0];
        const lastSessionTime = sessionTimes[sessionTimes.length - 1];
        const endTime = this.addTime(lastSessionTime, sessionDuration);

        LoggerService.log(`${day}: ${startTime} to ${endTime} (last session: ${lastSessionTime} + ${sessionDuration})`);

        if (startTime < earliestStart) earliestStart = startTime;
        if (endTime > latestEnd) latestEnd = endTime;
      }
    });

    if (hasAnyTimes) {
      const paddedStart = this.subtractTime(earliestStart, '01:00:00');
      const paddedEnd = this.addTime(latestEnd, '01:00:00');

      LoggerService.log(`Overall range: ${earliestStart} to ${latestEnd}`);
      LoggerService.log(`With padding: ${paddedStart} to ${paddedEnd}`);
    } else {
      LoggerService.log('No session times configured for any day');
    }
  }

  // Override processAMTSessionTime for week view to handle multiple days
  protected override processAMTSessionTime(): void {
    if (!this.AMTSessionTime || typeof $ === 'undefined') return;

    try {
      // Reset all slot backgrounds first
      $('td.fc-timegrid-slot').css("background", "");

      // Process session times for each day of the week in the current view
      const startDate = moment(this.newDateStart);
      const endDate = moment(this.newDateEnd);
      const daysOfWeek = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

      // Iterate through each day in the week view
      for (let currentDate = startDate.clone(); currentDate.isBefore(endDate); currentDate.add(1, 'day')) {
        const dayName = daysOfWeek[currentDate.day()];
        const dataObject = this.AMTSessionTime;

        if (dataObject && dataObject[dayName] && Array.isArray(dataObject[dayName])) {
          dataObject[dayName].forEach((timeSlotStr: string) => {
            // Approach 1: Direct data-time attribute
            const selector1 = `td.fc-timegrid-slot[data-time="${timeSlotStr}"]`;
            $(selector1).css("background", "#ccc");

            // Approach 2: Try different time formats (HH:mm)
            const timeShort = timeSlotStr.substring(0, 5); // "10:00:00" -> "10:00"
            const selector2 = `td.fc-timegrid-slot[data-time="${timeShort}"]`;
            $(selector2).css("background", "#ccc");

            // Approach 3: Find slots by text content (for time labels)
            const selector3 = `td.fc-timegrid-slot:contains("${timeShort}")`;
            $(selector3).css("background", "#ccc");

            // Approach 4: More specific targeting by time and date
            // Look for the time axis first, then find corresponding slots
            const timeAxisSelector = `.fc-timegrid-slot-label:contains("${timeShort}")`;
            const timeAxisElements = $(timeAxisSelector);
            if (timeAxisElements.length > 0) {
              timeAxisElements.each(function() {
                const $timeLabel = $(this);
                const $parentRow = $timeLabel.closest('tr');
                if ($parentRow.length) {
                  const $slots = $parentRow.find('td.fc-timegrid-slot:not(.fc-timegrid-slot-label)');

                  // Target only the slot for the specific day
                  $slots.each(function() {
                    const $slot = $(this);
                    const columnIndex = $slot.index() - 1; // Subtract 1 for the time label column
                    const targetDayIndex = currentDate.day();

                    if (columnIndex === targetDayIndex) {
                      $slot.css("background", "#ccc");
                    }
                  });
                }
              });
            }
          });
        }
      }
    } catch (e) {
      LoggerService.warn("Error processing AMTSessionTime for week view:", e);
    }
  }

  /**
   * Load studio timezone information before rendering calendar
   * This ensures the calendar displays times correctly for the studio's timezone
   */
  private loadStudioTimezone(): void {
    LoggerService.log('[WEEK-VIEW TIMEZONE] Loading studio timezone info...');

    this.studioConfigSubscription?.unsubscribe();
    this.studioConfigSubscription = this.studioConfigService.getStudioConfig().subscribe({
      next: (config) => {
        // Skip null emissions - config is still loading
        // BehaviorSubject emits null initially before the API call completes
        if (config === null) {
          LoggerService.log('[WEEK-VIEW TIMEZONE] Config is null, still loading...');
          return;
        }

        const configuredTimezone = config?.['field_studio_timezone']?.[0]?.value;

        // Check if timezone is actually configured
        if (!configuredTimezone) {
          LoggerService.warn('[WEEK-VIEW TIMEZONE] No timezone configured for this studio');
          this.studioTimezoneMissing = true;
          this.studioTimezoneLoaded = true; // Mark as loaded so we can show the error message
          return;
        }

        this.studioTimezone = configuredTimezone;
        this.studioTimezoneMissing = false; // Reset in case it was previously set
        LoggerService.log('[WEEK-VIEW TIMEZONE] Studio timezone loaded:', this.studioTimezone);

        // Set timezone in calendar options before marking as loaded
        if (this.calendarOptions) {
          this.calendarOptions.timeZone = this.studioTimezone;
          LoggerService.log('[WEEK-VIEW TIMEZONE] Set calendarOptions.timeZone to:', this.studioTimezone);

          const countryCode = config?.['field_studio_address']?.[0]?.country_code;
          const headerFormat = this.localizationService.isDayFirst(countryCode) ? 'ddd D/M' : 'ddd M/D';
          // Format the day headers via FullCalendar's own dateEnv (driven by the moment
          // plugin's cmdFormatter), NOT by re-running moment over arg.date.
          // A dayHeaderContent callback receives arg.date = dateEnv.toDate(marker), which
          // converts the column's wall-date marker into a real instant in the studio
          // timezone. For a tz ahead of UTC that instant falls on the previous calendar
          // day, so both moment(arg.date) and moment.utc(arg.date) label every column one
          // day behind (Sun 6/7 → Sat 6/6). dayHeaderFormat lets FullCalendar format the
          // marker directly with the studio tz, the same engine the title uses, so the
          // headers stay in sync with the columns and the title range.
          this.calendarOptions.dayHeaderFormat = headerFormat as any;
          delete this.calendarOptions.dayHeaderContent;
        }

        // Mark as loaded - this triggers the *ngIf to render the calendar
        this.studioTimezoneLoaded = true;
        LoggerService.log('[WEEK-VIEW TIMEZONE] studioTimezoneLoaded set to true, calendar will now render');
      },
      error: (error) => {
        LoggerService.error('[WEEK-VIEW TIMEZONE] Error loading studio timezone:', error);
        // On error, show the missing timezone message rather than silently using a fallback
        this.studioTimezoneMissing = true;
        this.studioTimezoneLoaded = true;
      }
    });
  }
}
